import AwardsLayout from "@pages/awards/AwardsLayout";
import { awards_routes } from "@/routes/awards";
import { filterRoutes } from "@/utils/featureFlipDependepent";

export const normalRoutes = filterRoutes([
  {
    path: "/awards",
    caseSensitive: true,
    element: <AwardsLayout />,
    children: awards_routes,
  },
], "normal");
